import React from 'react';
import * as css from './leadItem.css';
import _ from 'lodash';
import Copy from '../../../copy/Copy';
import {formatNumber} from '../../../../library/numberFunction';

function LeadItem({data, index, t, dataKeys, eventLink}){
    return (
        <css.leadItem key={index}>
            <css.leadHeader>
                <css.leadName>{data.name}</css.leadName>
                {_.has(data, 'status') && <css.statusIndicator $status={data.status} />}
            </css.leadHeader>
        
            <css.leadStats>
                {dataKeys.map((key, index) => (
                    _.has(data, key.key) &&
                <React.Fragment key={key.key+index}>
                    <css.statItem>
                        {t(key.label)}: {key.transform ? key.transform(data[key.key]) : formatNumber(data[key.key])}{key.suffix}
                    </css.statItem>
                </React.Fragment>
                ))}
                {_.has(data, 'ref') && (
                    <css.statItem>
                        <Copy link={`${eventLink}?ref=${data.ref}`} className=''/>
                    </css.statItem>
                )}
            </css.leadStats>
        </css.leadItem>
    );
}   
export default LeadItem;